document.addEventListener('DOMContentLoaded', function() {
  // Initialize Video Gallery
  const videoGalleries = document.querySelectorAll('.video-gallery');
  
  videoGalleries.forEach(gallery => {
    // Set CSS variables based on data attributes
    const columnsDesktop = gallery.getAttribute('data-columns-desktop') || '3';
    const columnsTablet = gallery.getAttribute('data-columns-tablet') || '2';
    const columnsMobile = gallery.getAttribute('data-columns-mobile') || '1';
    const imageSpacing = gallery.getAttribute('data-spacing') || '16';
    
    gallery.style.setProperty('--columns-desktop', columnsDesktop);
    gallery.style.setProperty('--columns-tablet', columnsTablet);
    gallery.style.setProperty('--columns-mobile', columnsMobile);
    gallery.style.setProperty('--image-spacing', imageSpacing);
    
    // Initialize filtering
    initializeFiltering(gallery);
    
    // Initialize video thumbnails
    initializeVideoThumbnails(gallery);
    
    // Log initialization for debugging
    console.log('Video gallery initialized');
  });
  
  // Initialize filtering
  function initializeFiltering(gallery) {
    const filterButtons = gallery.querySelectorAll('.video-gallery__filter-button');
    const items = gallery.querySelectorAll('.video-gallery__item');
    
    if (filterButtons.length === 0) return;
    
    filterButtons.forEach(button => {
      button.addEventListener('click', function() {
        const filter = this.getAttribute('data-filter');
        
        // Update active button
        filterButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        
        // Filter items
        items.forEach(item => {
          if (filter === 'all') {
            item.classList.remove('hidden');
          } else {
            if (item.classList.contains(`filter-${filter}`)) {
              item.classList.remove('hidden');
            } else {
              item.classList.add('hidden');
            }
          }
        });
      });
    });
  }
  
  // Initialize video thumbnails and click handlers
  function initializeVideoThumbnails(gallery) {
    // Set custom aspect ratio if selected
    if (gallery.getAttribute('data-aspect-ratio') === 'custom') {
      const items = gallery.querySelectorAll('.video-gallery__item');
      items.forEach(item => {
        item.style.aspectRatio = '1.5/1'; // Match the image gallery ratio
      });
    }
    
    const videoItems = gallery.querySelectorAll('.video-gallery__item');
    const modal = document.querySelector('.video-gallery__modal');
    const modalContent = modal.querySelector('.video-gallery__modal-video-container');
    const closeButton = modal.querySelector('.video-gallery__modal-close');
    const autoplayVideos = gallery.getAttribute('data-autoplay-videos') === 'true';
    
    videoItems.forEach(item => {
      const playButton = item.querySelector('.video-gallery__play-button');
      const customVideoUrl = item.getAttribute('data-custom-video-url');
      const youtubeUrl = item.getAttribute('data-youtube-url');
      const vimeoUrl = item.getAttribute('data-vimeo-url');
      
      if (playButton) {
        playButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Clear previous content
          modalContent.innerHTML = '';
          
          if (customVideoUrl) {
            console.log('Opening custom video:', customVideoUrl);
            
            // Create video element
            const video = document.createElement('video');
            video.controls = true;
            video.playsInline = true;
            video.autoplay = autoplayVideos;
            video.className = 'video-gallery__modal-video';
            
            // Add source
            const source = document.createElement('source');
            source.src = customVideoUrl;
            source.type = 'video/mp4';
            video.appendChild(source);
            
            // Add fallback text
            video.appendChild(document.createTextNode('Your browser does not support the video tag.'));
            
            // Add to modal
            modalContent.appendChild(video);
            
            // Show modal
            modal.classList.add('active');
            document.body.style.overflow = 'hidden';
            
            // Try to play the video after modal is visible
            setTimeout(() => {
              video.play().catch(e => console.log('Auto-play prevented:', e));
            }, 300);
          } 
          else if (youtubeUrl) {
            // Extract YouTube ID
            const youtubeId = extractYoutubeId(youtubeUrl);
            if (youtubeId) {
              const iframe = document.createElement('iframe');
              iframe.src = `https://www.youtube.com/embed/${youtubeId}?rel=0&showinfo=0${autoplayVideos ? '&autoplay=1' : ''}`;
              iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
              iframe.allowFullscreen = true;
              
              modalContent.appendChild(iframe);
              modal.classList.add('active');
              document.body.style.overflow = 'hidden';
            }
          }
          else if (vimeoUrl) {
            // Extract Vimeo ID
            const vimeoId = extractVimeoId(vimeoUrl);
            if (vimeoId) {
              const iframe = document.createElement('iframe');
              iframe.src = `https://player.vimeo.com/video/${vimeoId}?title=0&byline=0&portrait=0${autoplayVideos ? '&autoplay=1' : ''}`;
              iframe.allow = 'autoplay; fullscreen; picture-in-picture';
              iframe.allowFullscreen = true;
              
              modalContent.appendChild(iframe);
              modal.classList.add('active');
              document.body.style.overflow = 'hidden';
            }
          }
        });
      }
      
      // Make the whole item clickable
      item.addEventListener('click', function(e) {
        if (!e.target.closest('.video-gallery__play-button')) {
          const playButton = this.querySelector('.video-gallery__play-button');
          if (playButton) {
            playButton.click();
          }
        }
      });
    });
    
    // Close modal
    closeButton.addEventListener('click', function() {
      closeModal();
    });
    
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        closeModal();
      }
    });
    
    // Close modal with Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal();
      }
    });
    
    function closeModal() {
      modal.classList.remove('active');
      document.body.style.overflow = '';
      
      // Stop videos when modal is closed
      setTimeout(() => {
        modalContent.innerHTML = '';
      }, 300);
    }
  }
  
  // Helper function to extract YouTube ID
  function extractYoutubeId(url) {
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  }
  
  // Helper function to extract Vimeo ID
  function extractVimeoId(url) {
    if (!url) return null;
    const regExp = /vimeo\.com\/([0-9]+)/;
    const match = url.match(regExp);
    return match ? match[1] : null;
  }
});